import { Divider } from '@mui/material'
import { PlanType } from '@labrav/react-components'
import {
  AzureOfferPlan,
  AzurePricingType,
} from '../../../modules/privateOffer/types'
import {
  useStyles,
  useStyles as usePricingStyles,
} from '../MicrosoftViewPricing.styles'
import { PlanBasicDetail } from '../PlanBasicDetail/PlanBasicDetail'
import { SectionWrapper } from '../../../common/components/SectionWrapper/SectionWrapper'
import { faListCheck } from '@fortawesome/pro-regular-svg-icons'
import {
  DetailInfo,
  DetailRow,
} from '../../../common/components/DetailRow/DetailRow'
import {
  getContainerCustomMeters,
  getContainerPlanTcvValue,
  getContainerSystemMeterPriceTitle,
  getMeterDisplayName,
  hasCustomMeteringDimensions,
  shouldShowContainerTcv,
} from '../../MicrosoftFormComponent/ContainerPlan/containerPlanUtils'
import { DisplayNumberValue } from '../PlanMeteringDimensions/PlanMeteringDimensions'
import { useStyles as useMeteringStyles } from '../PlanMeteringDimensions/PlanMeteringDimensions.styles'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import clsx from 'clsx'
import { ViewValueWithTruncate } from '@labrav/common'

export const ContainerViewPricing = ({
  plans,
  azurePricingType,
  planType = PlanType.CONTAINER,
}: {
  plans?: AzureOfferPlan[]
  azurePricingType?: AzurePricingType
  planType?: PlanType
}) => {
  const { classes } = useStyles()
  const { classes: meteringClasses } = useMeteringStyles()
  const { classes: pricingClasses } = usePricingStyles()
  const productContext = { productType: planType }

  if (!plans || plans.length === 0) {
    return (
      <div>
        <SectionWrapper heading="Pricing Plans" icon={faListCheck}>
          <div className={classes.sectionContent}>
            <div className={classes.emptyState}>No plans available</div>
          </div>
        </SectionWrapper>
      </div>
    )
  }

  return (
    <div>
      <SectionWrapper heading="Pricing configuration" icon={faListCheck}>
        <div className={classes.sectionContent}>
          {plans.map((plan, index) => {
            const showTcv = shouldShowContainerTcv(plan, productContext)
            const showCustomMeters = hasCustomMeteringDimensions(plan)
            const customMeters = getContainerCustomMeters(plan)

            return (
              <div
                key={plan.labraPlanId || plan.planId || index}
                className={classes.planCard}
              >
                <PlanBasicDetail
                  azurePricingType={azurePricingType}
                  plan={plan}
                  index={index}
                />

                {showTcv && (
                  <>
                    <Divider className={classes.divider} />
                    <div
                      className={pricingClasses.subHeading}
                      style={{ marginBottom: '-24px' }}
                    >
                      Billing Terms
                    </div>
                    <DetailRow borderBottom>
                      <>
                        <DetailInfo
                          title={getContainerSystemMeterPriceTitle(
                            plan,
                            azurePricingType
                          )}
                          value={
                            <DisplayNumberValue
                              isPrice
                              shouldFormat
                              isPrecisionDigit={false}
                              value={getContainerPlanTcvValue(plan)}
                            />
                          }
                          keyName="containerTcv"
                          gridSize={4}
                        />
                      </>
                    </DetailRow>
                  </>
                )}

                {showCustomMeters && (
                  <>
                    <Divider className={classes.divider} />
                    <div className={pricingClasses.subHeading}>
                      Metering dimensions
                    </div>
                    <TableContainer
                      component={Paper}
                      className={meteringClasses.tableContainer}
                    >
                      <Table className={meteringClasses.table}>
                        <TableHead>
                          <TableRow className={meteringClasses.headerRow}>
                            <TableCell className={meteringClasses.headerCell}>
                              Name
                            </TableCell>
                            <TableCell className={meteringClasses.headerCell}>
                              Unit
                            </TableCell>
                            <TableCell
                              className={clsx(
                                meteringClasses.headerCell,
                                meteringClasses.textRight
                              )}
                            >
                              Price per unit
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody className={meteringClasses.tableBody}>
                          {Object.entries(customMeters).map(
                            ([meterKey, meterValue]) => (
                              <TableRow
                                key={meterKey}
                                className={meteringClasses.dataRow}
                              >
                                <TableCell className={meteringClasses.dataCell}>
                                  <ViewValueWithTruncate
                                    value={getMeterDisplayName(
                                      meterValue,
                                      meterKey
                                    )}
                                  />
                                </TableCell>
                                <TableCell className={meteringClasses.dataCell}>
                                  {meterValue?.unitOfMeasure || '-'}
                                </TableCell>
                                <TableCell
                                  className={clsx(
                                    meteringClasses.dataCell,
                                    meteringClasses.textRight
                                  )}
                                >
                                  <DisplayNumberValue
                                    value={meterValue?.pricePerPaymentInUsd}
                                    isPrice
                                    shouldFormat
                                  />
                                </TableCell>
                              </TableRow>
                            )
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                )}
              </div>
            )
          })}
        </div>
      </SectionWrapper>
    </div>
  )
}
